import dynamic from 'next/dynamic'
import Link from 'next/link'
import { Grid, List, ListItem, Button, Typography } from '@mui/material'

// Types
import type { FooterBoxProps } from '@/types/components/molecules/footer/box'

// Components
const LogoShapeAtom = dynamic(() => import('@/components/atoms/shapes/logo'))

const FooterBoxMolecule = (props: FooterBoxProps) => {
	// Props
	const { items } = props

	return (
		<Grid container>
			<Grid
				size={{ xs: 4, md: 12 }}
				sx={{
					pl: 1,
					'& svg': {
						width: 'auto',
						height: 80
					}
				}}
			>
				<LogoShapeAtom />
			</Grid>

			<Grid size={12} mt={1}>
				<List sx={{ py: 0 }}>
					{items.map((item, index) => {
						return (
							<ListItem
								key={index}
								color="text.secondary"
								sx={{
									p: 0,
									'& a': { width: 1 }
								}}
							>
								<Link href={item.link_value} target="_blank">
									<Button
										variant="text"
										sx={{
											width: 1,
											textAlign: 'inherit',
											textTransform: 'uppercase',
											color: 'common.black'
										}}
									>
										<Typography component="span" width={1} fontSize={{ xs: 12, md: 14 }} fontWeight={700}>
											{item.title}
										</Typography>
									</Button>
								</Link>
							</ListItem>
						)
					})}
				</List>
			</Grid>
		</Grid>
	)
}

export default FooterBoxMolecule
